<template>
  <div>
    <el-dialog title="产品品名预览表"
               width="970px"
               :visible.sync="visibleValue"
               :append-to-body="true"
               @closed="dialogClose">
      <el-form label-width="70px"
               :model="searchForm"
               inline>
        <el-form-item label="国家">
          <el-select
            v-model="searchForm.countryId"
            filterable
            clearable
            @change="changeCountry"
            :loading="loadingCountryList"
            placeholder="请选择国家"
            class="select-country"
          >
            <el-option
              v-for="item in baseCountryList"
              :key="item.id"
              :label="item.namec"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="产品品名">
          <el-input v-model="searchForm.productName"
                    placeholder="请输入产品品名"
                    class="input-name"></el-input>
        </el-form-item>
        <el-form-item label="货物类型">
          <el-input v-model="searchForm.productTypeFirstName"
                    class="input-name"
                    placeholder="请输入货物类型"></el-input>
        </el-form-item>
        <el-form-item label="产品类型">
          <el-input v-model="searchForm.productTypeSecondaryName"
                    class="input-name"
                    placeholder="请输入产品类型"></el-input>
        </el-form-item>
        <el-form-item label="" label-width="10px">
          <el-button type="primary" @click="handleSearch">查询</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="tableData"
                height="300px"
                :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
                border
                size="mini"
                :span-method="cellMerge">
        <el-table-column label="货物类型"
                         prop="productTypeFirstName"
                         align="center"
                         width="100px"></el-table-column>
        <el-table-column label="产品类型"
                         prop="productTpeSecondaryName"
                         align="center"
                         width="150px"></el-table-column>
        <el-table-column label="产品品名" align="center">
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.productList.join(',')" placement="top" popper-class="cus-popper">
              <div class="product-name-overflow">
                {{ scope.row.productList.join(',') }}
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="附加费"
                         prop="price"
                         align="center"
                         width="70px"></el-table-column>
        <el-table-column label="币种"
                         prop="currency"
                         align="center"
                         width="70px"></el-table-column>
      </el-table>

      <div style="margin-top: 20px">
        <el-alert title="温馨提示：产品品名预览表的附加费为平台价格。" type="warning" effect="light"  :closable="false"></el-alert>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {mixinsDialog} from "my-element-mixins";

export default {
  name: "productNamePreview",
  mixins:[mixinsDialog],
  props: {
    countryList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      searchForm: {
        countryId: undefined,
        productName: '',
        productTypeFirstName: '',
        productTypeSecondaryName: ''
      },
      tableData: [],
      loadingCountryList:false,
      baseCountryList: [],
      productTypeFirstNameLength: []
    }
  },
  watch: {
    visibleValue: {
      immediate: true,
      handler(val) {
        if (val) {
          this.baseCountryList = this.countryList
          this.searchForm.countryId = this.countryList.filter(v => v.code === 'US')[0].id
          this.handleSearch()
        }
      }
    }
  },
  methods: {
    handleSearch() {
      const params = {...this.searchForm}
      this.axios.post('/product/findProductNamePreviewList', params)
        .then(res => {
          if (res.data.code == 200) {
            this.tableData = this.dataFormat(res.data.datas)
          }
        })
    },
    /**
     * 筛选 目的国
     */
    // filterCountry(value){
    //   this.loadingFilterCountry = true;
    //   if(!value && value !== 0) {
    //     this.baseCountryList = this.countryList;
    //     this.loadingFilterCountry = false;
    //     return true;
    //   }
    //   value = value.toLowerCase();
    //   this.baseCountryList = this.countryList.filter(item=>{
    //     let namec =`${item.namec||""}`.toLowerCase();
    //     // let namee =`${item.namee||""}`.toLowerCase();
    //     // let code =`${item.code||""}`.toLowerCase();
    //     // return namec.match(value) || namee.match(value) || code.match(value);
    //     return namec.match(value);
    //   })
    //   this.loadingFilterCountry = false;
    // },
    /**
     * 目的国 输入框获得焦点
     */
    // handleFocusCountry(){
    //   this.filterCountry();
    // },
    /**
     * 变更 目的国
     */
    changeCountry(value){
      this.searchForm.productName = "";
      this.searchForm.productTypeFirstName = ''
      this.searchForm.productTypeSecondaryName = ''
      this.tableData = []
    },
    dataFormat(arr) {
      let tableData = []
      arr.forEach(v => {
        v.productTpeSecondaryNameList.forEach(u => {
          const o = {
            ...v,
            currency: u.currency,
            price: u.price,
            productTpeSecondaryName: u.productTpeSecondaryName,
            productList: u.productList.map(item => item.productName)
          }
          tableData.push(o)
        })
      })
      this.getSpanArr(tableData)
      return tableData
    },
    cellMerge({ row, column, rowIndex, columnIndex }) {
      // if (columnIndex === 0 || columnIndex === 3 || columnIndex === 4) {
      if (columnIndex === 0) {
        const o = this.productTypeFirstNameLength[rowIndex]
        if (o.isFirst) {
          return {
            rowspan: o.length,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    },
    getSpanArr(data) {
      this.productTypeFirstNameLength = []
      data.forEach((item, index) => {
        if(index === data.findIndex(v => {
          return v.productTypeFirstName === item.productTypeFirstName
        })) {
          this.productTypeFirstNameLength.push({
            name: item.productTypeFirstName,
            length: item.productTpeSecondaryNameList.length,
            isFirst: true
          })
        } else {
          this.productTypeFirstNameLength.push({
            name: item.productTypeFirstName,
            length: item.productTpeSecondaryNameList.length,
            isFirst: false
          })
        }
      })
    },
    dialogClose() {
      Object.keys(this.searchForm).forEach(key => {
        this.searchForm[key] = ''
      })
      this.tableData = []
    }
  },
  mounted() {
    // this.baseCountryList = this.countryList.map(item => item)
    this.baseCountryList = this.countryList
  }
}
</script>
<style lang="scss" scoped>
$input-width: 120px;
.select-country {
  width: $input-width;
}
.input-name {
  width: 130px;
}
.product-name-overflow {
  max-height: 140px;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  white-space: normal;
  -webkit-line-clamp: 6;
  -webkit-box-orient: vertical;
}
</style>
<style lang="scss">
.cus-popper {
  max-width: 800px;
}
</style>



// WEBPACK FOOTER //
// common/productNamePreview/index.vue